const FOCUSABLE_SELECTOR =
  'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

export function getFocusableElements(container: HTMLElement): HTMLElement[] {
  return Array.from(container.querySelectorAll<HTMLElement>(FOCUSABLE_SELECTOR)).filter(
    (el) => !el.hasAttribute('disabled') && el.tabIndex !== -1,
  );
}

/** Move focus to the next or previous tab stop after `from`, inside its dialog. */
export function focusAdjacent(from: HTMLElement, backwards: boolean): void {
  const root =
    (from.closest('[role="dialog"], [aria-modal="true"]') as HTMLElement | null) ??
    document.body;
  const items = getFocusableElements(root).filter((el) => !el.closest('[data-wp-popover-panel]'));
  const index = items.indexOf(from);
  if (index < 0) return;
  items[index + (backwards ? -1 : 1)]?.focus();
}

export function focusFirstFocusable(container: HTMLElement): void {
  const focusables = getFocusableElements(container);
  if (focusables.length > 0) {
    focusables[0]!.focus();
    return;
  }
  if (container.tabIndex < 0) container.tabIndex = -1;
  container.focus();
}
